/**
 * Customer-facing release notes for the "What's new" page. This is content, not interface text.
 * Newest first. Keep each point short and in plain English; leave out internal and security-review detail.
 * Add an entry here when docs/CHANGELOG.md gets a customer-visible release.
 */
export interface ReleaseNote {
  version: string;
  /** Shown as written, for example "25 Oct 2026". */
  date: string;
  title: string;
  points: string[];
}

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    version: '0.4.0',
    date: '25 Oct 2026',
    title: 'Safety and site features',
    points: [
      'Evacuations: a live roll call in the portal, on kiosks and on marshals\' phones, with a report and PDF afterwards.',
      'Safety checks at sign-in: block list, compliance documents, inductions and site capacity.',
      'Permits to work, lone working check-ins and a panic button.',
      'Contactless sign-in from a poster QR code, deliveries, events, live occupancy, NFC cards and a reception display.',
    ],
  },
  {
    version: '0.3.1',
    date: '23 Oct 2026',
    title: 'Get the apps',
    points: ['A new "Get the apps" page with download buttons and QR codes for the Kiosk and Companion Android apps.'],
  },
  {
    version: '0.3.0',
    date: '23 Oct 2026',
    title: 'People and notifications',
    points: [
      'Pre-registration: invite visitors with a QR code and a personal pre-arrival page, with approvals.',
      'Notifications by email, text, webhook or phone, including host alerts and overstay alerts.',
      'The Companion phone app, history and timesheet reports, and the daily on-site email.',
      'Webhooks, API keys and a public API for other systems.',
    ],
  },
];
